import { commentTable } from 'component/comment';
import { BasicTeaser } from 'component/teaser';
import type { SimpleCommentsConfig } from 'structure/simple-comments';
import { TeaserScreen } from 'system/teaser';
import { useCollection } from 'util/datastore';
import type { Feature } from 'util/stdtypes';
import { t } from 'util/stdtypes';
export const BasicTeaserFeature: Feature<SimpleCommentsConfig, {}> = {
    name: 'Basic Teaser',
    key: 'basicteaser',
    providesConfig: {
        teaserScreen: BasicTeaserScreen,
    },
};

export function BasicTeaserScreen() {
    const comments = useCollection(commentTable);
    return (
        <TeaserScreen>
            <BasicTeaser formatParams={{ count: comments.length, singular: t('comment'), plural: t('comments') }} />
        </TeaserScreen>
    );
}
